export const MEMBER_LIST_FILE_NAME = "MemberList";
